import i18n from '@/commons/translations/i18n'
import { ValidationObserver } from 'vee-validate'
import { commonTranslations } from '@/commons/translations'
import { TranslationUtils } from '@/commons/utils/translations'
import { ApplicationType } from '@/commons/constants/application'
import citizenPassportTranslations from '@/citizen-passport/translations'

export class CitizenPassportVue extends ValidationObserver {
    applicationType = ApplicationType.CITIZEN_PASSPORT

    constructor () {
        super()
        this.setDomainTranslations()
    }

    setDomainTranslations (): void {
        TranslationUtils.combineTranslations(
            i18n,
            Object.keys(citizenPassportTranslations),
            commonTranslations,
            citizenPassportTranslations
        )
    }
}
